<ion-app>
  <ion-menu side="start">
    <ion-header >
      <ion-toolbar color="secondary" class="ion-padding">
          <ion-img class="logo" src="assets/img/goldenpig.png"></ion-img>
      </ion-toolbar>
    </ion-header>

    <ion-content>
      <ion-list>
        <ion-menu-toggle>
          <ion-item lines="none" routerLink= "/" button >
            <ion-icon color="dark" name="reader-outline" slot="start"></ion-icon>
            <ion-label color="dark">Dashboards</ion-label>
          </ion-item> 
        </ion-menu-toggle>
        <ion-menu-toggle>
          <ion-item lines="none" (click)="onLogout()" button>
            <ion-icon color="dark" name="exit-outline" slot="start"></ion-icon>
            <ion-label color="dark">Logout</ion-label>
          </ion-item> 
        </ion-menu-toggle>
      </ion-list>
    </ion-content>
  </ion-menu>
  <ion-router-outlet main></ion-router-outlet>
</ion-app>
